import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { CaseStatusService } from '../../case-status/services/case-status.service';
import { Subject,} from 'rxjs';
import { ConfirmationService} from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { environment } from 'environment-configurations';


@Component({
  selector: 'app-past-documents',
  templateUrl: './past-documents.component.html',
  styleUrls: ['./past-documents.component.scss']
})
export class PastDocumentsComponent implements OnInit {

  pastDocumentsList = [];
  totalElementCount = 0;
  pageSizeOptions = [25, 50, 100];
  pageIndex = 1; // default
  pageSize = 25; // default
  searchText = '';
  menuItems: { key: string, value: string }[] = [];
  payload = {
    pageNumber: this.pageIndex,
    pageSize: this.pageSize,
    searchText:''
  };
  observableSubscription$ = new Subject();
  cols: any[];

  pastDocumentsCols: { field: string; header: string; width?: string; cssClass?: string; }[];
  navUrl;
  editNavUrl;
  display: boolean = false;
  selectFotmtype;
  formList;
  employeeTab;
  constructor(
    private router: Router,
    private APIService : CaseStatusService,
    private confirmationService: ConfirmationService,
    private petitionerService: PetitionerService,
    public toastr: ToastrService) { }

  ngOnInit(): void {
    this.menuItems = [
      { key: 'EMPINFO', value: 'Section 1 - Employee Information' },
      { key: 'EMPREVIEW', value: 'Section 2 - Employee or Authorized Representative Review & Verification' },
      { key: 'EMPREVERIFICATION', value: 'Section 3 - Reverification & Rehire(Supplement B)' }
    ];

    this.pastDocumentsCols = [
      { field: 'docName', header: 'Document Name', width: '50%' },
      { field: 'docType', header: 'Document Type', width: '50%' },
    ];
    this.cols = this.pastDocumentsCols;
    this.formList = [{
      name: "File Doc1",
      id: 101
    },
    {
      name: "File Doc2",
      id: 102
    },
    {
      name: "File Doc3",
      id: 103
    }];
    this.getI9PastDocument();
    this.handleKeySelection(this.menuItems[0].key);
  }

  handleKeySelection(key){
    if(key === 'EMPINFO'){
      this.employeeTab = 'EMPINFO';
    }else  if(key === 'EMPREVIEW'){
      this.employeeTab = 'EMPREVIEW';
    }else  if(key === 'EMPREVERIFICATION'){
      this.employeeTab = 'EMPREVERIFICATION';
    }
  }

  selectFormChanges(){
  }

  getI9PastDocument(){
    this.pastDocumentsList = [
      {
        docName : 'Form-I9.Pdf',
        docType : 'I-9 Section 1',
        id: 1,
        file: '',
        fileLocation : "/var/imagility/uploads/documents/company/242/petition/759/1700818502265.pdf"
      },
      {
        docName : 'I9-Details.Pdf',
        docType : 'Us Passport',
        id: 2,
        file: '',
        fileLocation : "/var/imagility/uploads/documents/company/242/petition/759/1700818502265.pdf"
      },
      {
        docName : 'I9-Forms.Pdf',
        docType : 'Marshal Island',
        id: 3,
        file: '',
        fileLocation : "/var/imagility/uploads/documents/company/242/petition/759/1700818502265.pdf"
      },
    ]
  }

  paginationEvent(event) {
    this.payload.pageNumber = event.page + 1;
    this.payload.pageSize = event.rows;
    this.getI9PastDocument();
  }

  backToDashboard() {
    this.router.navigate(['petitioner-landing/dashboard/petitioner-dashboard']);
  }

  addI9Doc(){
    this.router.navigate([this.navUrl])
  }

  editPastDoc(id){
    // this.router.navigate([this.editNavUrl + id]);
  }

  viewPastDoc(item) {  
    const docPath = item.fileLocation.substring(23);
    window.open(`${environment.docs}${docPath}`, '_blank');
  }

  downloadPastDoc(file) {  
    this.petitionerService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
  }

  deleteI9PastDoc(caseId){
    this.APIService.deleteCase(caseId)
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((response) => {
      this.getI9PastDocument();
      this.toastr.success(response.message);
    });
  }

  confirmPastDocDelete(item){
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      key:'deletePastDoc',
      accept: () => {
        this.deleteI9PastDoc(item.id);
      },
      reject: () => {
      }
    });
  }

  cancelDialog(){
    this.display = false;
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
